module.exports = __webpack_public_path__ + "static/media/admission.5b267ce7.pdf";